import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-why-atom-text-box',
  template: `
    <ion-input [attr.type]="_type" [id]="'email'" [ngClass]="_inputClass" [name]="_formControlName"
               [placeholder]="_placeHolderText | translate">
    </ion-input>
  `,
  styles: []
})

export class AtomTextBoxComponent implements OnInit {

  @Input() _formControlName: string;
  @Input() _id: string;
  @Input() _type: string;
  @Input() _placeHolderText: string;
  @Input() _autoComplete: string;
  @Input() _inputClass: string;

  constructor() {
  }

  ngOnInit(): void {
  }
}
